export default __webpack_public_path__ + "static/media/BS04.d8e7f734.jpg";